export const toSlug = (str = "") =>
  str
    .toString()
    .trim()
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^\w\s-]/g, "")   // remove special chars
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-");
